import { CasesService } from "./../services";
import { defineStore } from "pinia";

export type UnseenCasesStoreState = {
  unseenCases: Set<string>;
  unseenCaseData: Record<string, string[]>;
};

const state = (): UnseenCasesStoreState => ({
  unseenCases: new Set(),
  unseenCaseData: CasesService.getUnseenCaseData(),
});

export const useUnseenCasesStore = defineStore("unseenCases", {
  state,
  actions: {
    saveUnseenCaseData({ caseId, dataId }: { caseId: string; dataId: string }) {
      if (this.unseenCaseData[caseId]) {
        this.unseenCaseData[caseId].push(dataId);
      } else {
        this.unseenCaseData[caseId] = [dataId];
      }
      this.unseenCaseData[caseId] = Array.from(new Set(this.unseenCaseData[caseId]));

      CasesService.saveUnseenCaseData(this.unseenCaseData);
    },

    removeUnseenCaseData({ caseId }: { caseId: string }) {
      delete this.unseenCaseData[caseId];

      CasesService.saveUnseenCaseData(this.unseenCaseData);
    },

    isDataUnread({ caseId, dataId }: { caseId: string; dataId: string }): boolean {
      return !!this.unseenCaseData[caseId]?.includes(dataId);
    },

    clearUnseenCaseData(): void {
      CasesService.clearUnseenCaseData();
    },

    saveUnseenCase({ caseId }: { caseId: string }): void {
      this.unseenCases.add(caseId);
    },

    removeUnseenCase({ caseId }: { caseId: string }): void {
      this.unseenCases.delete(caseId);
      this.removeUnseenCaseData({ caseId });
    },

    onSessionEnd(): void {
      this.unseenCases = new Set();
      this.unseenCaseData = {};
      this.clearUnseenCaseData();
    },
  },
});
